import { Link } from "react-router-dom";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_energy-capital/artifacts/grlkru8i_sunly%20logo%20low%20res.jpg";

export const Logo = ({ variant = "light", withText = true, className = "" }) => {
  const isDark = variant === "dark";
  return (
    <Link
      to="/"
      data-testid="site-logo"
      className={`flex items-center gap-3 ${className}`}
    >
      <span
        className={`inline-flex items-center justify-center overflow-hidden ${
          isDark ? "bg-white rounded-md p-1.5 shadow-sm" : ""
        }`}
      >
        <img
          src={LOGO_URL}
          alt="Sunly Prime"
          className={`h-8 w-auto object-contain ${isDark ? "" : "mix-blend-multiply"}`}
        />
      </span>
      {withText && (
        <span
          className={`font-serif text-lg tracking-wide leading-none pt-0.5 ${
            isDark ? "text-white/90" : "text-sp-deep"
          }`}
        >
          <span className="font-normal">PRIME</span>
        </span>
      )}
    </Link>
  );
};

export default Logo;
